module.exports = __webpack_public_path__ + "assets/images/cosmote_start.22c73008496e83f94afd4df67d6e5d8e.png";